import { useAtomValue } from 'jotai';
import { ROUTES } from '../../constants/routes';
import { Unauthorized } from '../../pages/Unauthorized/Unauthorized';
import { userState } from '../../state/UIState';
import { useMemo } from 'react';
import { allowedPages } from '../../utils/roles';

type Props = {
  component: JSX.Element;
  path: ROUTES;
};

export const GuardedRoute = ({ component: Component, path }: Props) => {
  const user = useAtomValue(userState);

  // Multi-role: a path is allowed if it is in the UNION of the page sets of every role the user holds
  // (see allowedPages). This subsumes the old single-role pages/adminPages/OPPages/OPAdminPages branching.
  const canSee = useMemo(() => allowedPages(user).includes(path), [user, path]);

  return canSee ? Component : <Unauthorized />;
};
